module.exports = __webpack_public_path__ + "img/goals.befe502c.png";